// extracted by mini-css-extract-plugin
export default {"modalContent":"PointOfSale__modalContent--ZWZPn","customModal":"PointOfSale__customModal--t-8Ec","submitBtn":"PointOfSale__submitBtn--a2dyy"};